import { Link } from "react-router-dom";
import { ArrowRight, ChevronRight } from "lucide-react";
import { StatusBadge } from "@/components/kit";
import { fdate, inr, num } from "@/lib/format";

export function TxnRow({ t, showStatus = true }) {
  const qty = t.quantity ? `${num(t.quantity)} ${t.unit || ""} · ` : "";
  return (
    <Link to={`/txn/${t.id}`} data-testid={`txn-row-${t.id}`} className="flex items-center gap-3 py-3 border-b border-[#E2D9CF]/50 last:border-0 hover:bg-[#FBF8F4] -mx-4 px-4 transition-colors">
      <div className="min-w-0 flex-1">
        <div className="text-sm font-semibold truncate">{t.type_label} · {t.asset_name}</div>
        <div className="text-xs text-[#718096] mt-0.5 truncate">{qty}{fdate(t.date)} · by {t.created_by_name}</div>
        {showStatus && <div className="mt-1.5"><StatusBadge status={t.status} /></div>}
      </div>
      <div className="text-right shrink-0">
        <div className="text-sm font-bold tabular-nums">{inr(t.total_value)}</div>
      </div>
      <ChevronRight size={16} className="text-[#A0AEC0]" />
    </Link>
  );
}

export function SettlementRow({ s, showStatus = true }) {
  return (
    <Link to={`/settlement/${s.id}`} data-testid={`settlement-row-${s.id}`} className="flex items-center gap-3 py-3 border-b border-[#E2D9CF]/50 last:border-0 hover:bg-[#FBF8F4] -mx-4 px-4 transition-colors">
      <div className="min-w-0 flex-1">
        <div className="text-sm font-semibold flex items-center gap-1.5 flex-wrap">
          {s.from_name} <ArrowRight size={13} className="text-[#C8553D]" /> {s.to_name}
        </div>
        <div className="text-xs text-[#718096] mt-0.5 truncate">
          Settlement · {s.payment_mode} · {fdate(s.date)}{s.asset_name ? ` · ${s.asset_name}` : ""}
        </div>
        {showStatus && <div className="mt-1.5"><StatusBadge status={s.status} /></div>}
      </div>
      <div className="text-sm font-bold tabular-nums shrink-0">{inr(s.amount)}</div>
      <ChevronRight size={16} className="text-[#A0AEC0]" />
    </Link>
  );
}

export function ItemRow({ item }) {
  return item.kind === "settlement" ? <SettlementRow s={item} /> : <TxnRow t={item} />;
}
